module.exports = __webpack_public_path__ + "static/StaffAughover-4dba7f5ddde4e5b62df3484c00013467.png";